export default "<h3>June 21, 2019</h3>\r\n<p>Update 1.01 fixes some bugs.</p>";